__turbopack_context__.v({
  "background": "quCLyG_background",
  "form__input": "quCLyG_form__input",
  "form__message": "quCLyG_form__message",
  "form__submit_button": "quCLyG_form__submit_button",
  "inner": "quCLyG_inner",
  "inner_form": "quCLyG_inner_form",
  "inner_header": "quCLyG_inner_header",
  "inner_text": "quCLyG_inner_text",
  "loading_indicator": "quCLyG_loading_indicator",
  "newsletter": "quCLyG_newsletter",
});
